import type { DividaResource } from '@/models/resources';

export function isPrimeDividaHabilitada(divida: DividaResource): boolean {
  return divida.caracteristicas?.prime?.habilitado === true;
}
